module.exports = __webpack_public_path__ + "img/hero_mobile_3.bf897109.webp";